import styled from 'styled-components';

export const OwnershipCheckboxWrapper = styled.div`
  .ownership-checkbox {
    flex-wrap: wrap;
  }

  .ownership-checkbox > * {
    width: 50%;
  }
`;

export const OwnershipRadioButtonWrapper = styled.div`
  .ownership-radiobutton > div {
    flex-wrap: wrap;
  }

  .ownership-radiobutton > div > * {
    width: 50%;
    margin-left: unset;
  }
`;
